import React from 'react';
export const VipModuleSection = () => {
  const levels = [{
    title: 'Nivel 1 — Inicial',
    color: 'text-familia-green',
    items: ['Ejercicios en silla o cama y estimulación básica.']
  }, {
    title: 'Nivel 2 — Medio',
    color: 'text-blue-400',
    items: ['Fuerza, equilibrio y actividades de lógica cotidiana.']
  }, {
    title: 'Nivel 3 — Avanzado',
    color: 'text-purple-400',
    items: ['Coordinación, resistencia suave y desafíos mentales.']
  }];
  return <section id="vip" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-271">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-272">
        <div className="text-center mb-10 md:mb-16" data-id="element-273">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-274">
            ⚡ MÓDULO VIP — +150 ejercicios físicos y cognitivos
          </h2>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-275">
            Más de 150 actividades organizadas en 3 niveles para adaptar la
            rutina a las posibilidades reales del adulto mayor.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-276">
          {levels.map((level, i) => <div key={i} className="bg-familia-card border border-white/5 p-6 md:p-8 rounded-2xl" data-id="element-277">
              <h3 className={`text-lg md:text-xl font-bold mb-6 ${level.color}`} data-id="element-278">
                {level.title}
              </h3>
              <ul className="space-y-4" data-id="element-279">
                {level.items.map((item, j) => <li key={j} className="flex items-start gap-3 text-sm md:text-base text-white/90" data-id="element-280">
                    <span className={`${level.color} shrink-0`} data-id="element-281">→</span>
                    <span data-id="element-282">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};